<template>
  <div>
    <b-card class="col-12" no-body>
      <div class="m-2">
        <b-row>
          <b-col cols="12">
            <h4>
              Danh sách phiếu yêu cầu
              <a
                  v-b-tooltip.hover.top="'Lấy lại danh sách!'"
                  class="btn-icon"
                  @click="$router.go()"
              >
                <feather-icon icon="RepeatIcon"
                />
              </a>
            </h4>
          </b-col>
        </b-row>
        <validation-observer ref="modalEdit">
          <div class="p-1">
            <b-row>
              <b-col cols="12" md="3">
                <validation-provider name="ID">
                  <b-form-group label="ID">
                    <b-form-input
                        v-model="serverParams.id"
                        placeholder="ID"
                        type="number"
                    />
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12" md="3">
                <validation-provider #default="{ errors }" name="Ngày tạo">
                  <b-form-group label="Ngày tạo">
                    <b-input-group label="Ngày tạo">
                      <b-form-datepicker
                          v-model="serverParams.createdDate"
                          :date-format-options="{
                          year: 'numeric',
                          month: 'numeric',
                          day: 'numeric',
                        }"
                          :state="errors.length > 0 ? false : null"
                          close-button
                          locale="vi-VN"
                          reset-button
                          today-button
                      />
                    </b-input-group>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12" md="3">
                <validation-provider #default="{ errors }" name="Ngày bắt đầu">
                  <b-form-group label="Ngày bắt đầu">
                    <b-input-group label="Ngày bắt đầu">
                      <b-form-datepicker
                          v-model="serverParams.startDate"
                          :date-format-options="{
                          year: 'numeric',
                          month: 'numeric',
                          day: 'numeric',
                        }"
                          :state="errors.length > 0 ? false : null"
                          close-button
                          locale="vi-VN"
                          reset-button
                          today-button
                      />
                    </b-input-group>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12" md="3">
                <validation-provider #default="{ errors }" name="Ngày kết thúc">
                  <b-form-group label="Ngày kết thúc">
                    <b-input-group label="Ngày kết thúc">
                      <b-form-datepicker
                          v-model="serverParams.endDate"
                          :date-format-options="{
                          year: 'numeric',
                          month: 'numeric',
                          day: 'numeric',
                        }"
                          :state="errors.length > 0 ? false : null"
                          close-button
                          locale="vi-VN"
                          reset-button
                          today-button
                      />
                    </b-input-group>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12" md="3">
                <b-form-group label="Trạng thái">
                  <Select2
                      v-model="serverParams.type"
                      :options="dropListSelectData"
                      placeholder="Chọn trạng thái"
                  />
                </b-form-group>
              </b-col>
            </b-row>
          </div>
        </validation-observer>
        <b-row v-if="!isCreateForm" style="padding-inline: 14px">
          <b-col class="text-end mb-2" cols="12">
            <b-button
                class="btn"
                variant="primary"
                @click="$router.push('/noti-request/create')"
            >
              <feather-icon icon="PlusIcon" style="margin-right: 6px"/>
              Tạo phiếu yêu cầu
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <vue-good-table
                :columns="fields"
                :isLoading.sync="isLoading"
                :line-numbers="true"
                :pagination-options="{ perPage: serverParams.pageSize, enabled: true }"
                :rows="tableData"
                :sort-options="{
                enabled: false,
              }"
                :totalRows="totalRecords"
                class="vpbank-tb-container"
                mode="remote"
                @on-page-change="onPageChange"
                @on-sort-change="onSortChange"
                @on-per-page-change="onPerPageChange"
            >
              <template slot="table-row" slot-scope="props">
                <!-- Column: Action -->
                <span v-if="props.column.field === 'action'" class="action-container">
                  <b-button
                      v-if="props.row.isRepaired"
                      class="btn-icon"
                      size="sm"
                      variant="primary"
                      @click="$router.push(`/noti-request/edit/${props.row.id}`)"
                  >
                    <feather-icon icon="Edit2Icon"/>
                  </b-button>
                  <b-button
                      v-if="props.row.isRepaired"
                      class="btn-icon"
                      size="sm"
                      variant="primary"
                      @click="onDelete(props.row)"
                  >
                    <feather-icon icon="TrashIcon"/>
                  </b-button>
                  <b-button
                      class="btn-icon"
                      size="sm"
                      variant="primary"
                      @click="$router.push(`/noti-request/view/${props.row.id}`)"
                  >
                    <feather-icon icon="EyeIcon"/>
                  </b-button>
                </span>
                <span
                    v-else-if="
                    props.column.field === 'CreateDate' ||
                    props.column.field === 'activatedDate' ||
                    props.column.field === 'CallDate'
                  "
                >
                  {{ getDateTime(props.formattedRow[props.column.field]) }}
                </span>
                <span v-else-if="props.column.field === 'createdDate'">
                  {{ props.formattedRow[props.column.field] }}
                </span>
                <span v-else-if="props.column.field === 'status'">
                  <!-- {{
                    status.find(
                      (item) => item.id == props.formattedRow[props.column.field]
                    ) &&
                    status.find(
                      (item) => item.id == props.formattedRow[props.column.field]
                    ).text
                  }} -->
                  <span class="status-info">
                    {{ props.row["status"] === null ? "" : props.row["StatusText"] }}
                  </span>
                </span>
                <span v-else>
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>
            </vue-good-table>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>
<script>
import {ValidationObserver, ValidationProvider} from "vee-validate";
import vSelect from "vue-select";
import {VueGoodTable} from "vue-good-table";
import {
  BAvatar,
  BBadge,
  BButton,
  BCard,
  BCardText,
  BCol,
  BDropdown,
  BDropdownItem,
  BFormCheckbox,
  BFormCheckboxGroup,
  BFormDatepicker,
  BFormGroup,
  BFormInput,
  BFormRadioGroup,
  BFormSelect,
  BFormTextarea,
  BInputGroup,
  BLink,
  BMedia,
  BModal,
  BPagination,
  BRow,
  BTab,
  BTable,
  BTabs,
  BTooltip,
  VBTooltip,
} from "bootstrap-vue";
import useJwt from "@/auth/jwt/useJwt";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Ripple from "vue-ripple-directive";
import "@core/scss/vue/libs/vue-good-table.scss";
import Select2 from "v-select2-component";
import moment from "moment";
import flatPickr from "vue-flatpickr-component";
import Vue from "vue";
import VueExcelXlsx from "vue-excel-xlsx";

Vue.use(VueExcelXlsx);

export default {
  components: {
    BFormDatepicker,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    vSelect,
    FeatherIcon,
    BModal,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    BFormSelect,
    VueGoodTable,
    Select2,
    BTabs,
    BTab,
    BFormRadioGroup,
    BFormCheckboxGroup,
    BFormTextarea,
    BCardText,
    BInputGroup,
    flatPickr,
  },

  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  async mounted() {
    this.getTypeData();
    await this.getTableData();
  },
  computed: {},
  watch: {
    callStatusSelected(newValue, oldValue) {
    },
    serverParams: {
      immediate: true,
      deep: true,
      handler(val, oldVal) {
        clearTimeout(this.timeOut);
        this.timeOut = setTimeout(() => {
          this.getTableData();
        }, 500);
      },
    },
  },
  methods: {
    async getTypeData() {
      // const response = await useJwt.get(`GetRequestType`);
      // if (response.data.code === 200) {
      //   this.dropListSelectData = response.data.result.map((item) => ({
      //     id: item.id,
      //     text: item.value,
      //   }));
      // } else {
      //   this.dropListSelectData = [];
      // }
      this.dropListSelectData = [
        {
          id: 0,
          text: "Tất cả",
        },
        {
          id: 1,
          text: "Phiếu yêu cầu đã tạo",
        },
        {
          id: 2,
          text: "Phiếu yêu cầu cần duyệt",
        },
        {
          id: 3,
          text: "Phiếu yêu cầu đã duyệt",
        },
      ];
    },
    updateParams(newProps) {
      //TODO: check params
      // this.serverParams = Object.assign({}, this.serverParams, newProps);
      // console.log("newProps", newProps, this.serverParams);
      // if (this.serverParams.columnFilters.status == "") {
      //   delete this.serverParams.columnFilters.status;
      // }
    },
    onSelectOrderTime(val) {
      if (this.selectedOrderTime != val) {
        this.selectedOrderTime = val;
      }
    },
    async onPageChange(params) {
      this.serverParams.page = params.currentPage;
      // TODO: uncomment here
      // await this.getTableData();
    },
    onSortChange(params) {
      this.updateParams(params);
      // TODO: uncomment here
      // this.getTableData(false);
    },
    async onPerPageChange(params) {
      this.serverParams.pageSize = params.currentPerPage;
    },
    getFieldsTable(columns) {
      this.fields = columns.map((c) => {
        const key = Object.keys(c)[0];
        if (key === "status") {
          return {
            field: key,
            filterOptions: {
              enabled: false,
              placeholder: "",
              filterDropdownItems: this.status.map((el) => {
                return {...el, value: el.id};
              }),
            },
            label: c[key],
            required: true,
            disabled: true,
            tdClass: "text-center",
          };
        } else if (key === "action") {
          return {
            field: key,
            filterOptions: {enabled: false, placeholder: ""},
            label: c[key],
            required: true,
            disabled: true,
            tdClass: "text-center",
            width: "80px",
          };
        } else {
          return {
            field: key,
            filterOptions: {enabled: false, placeholder: ""},
            label: c[key],
            required: true,
            disabled: true,
            tdClass: "text-center",
            width:
                key === "ID"
                    ? "50px"
                    : key === "ContactNumber"
                        ? "100px"
                        : key === "CallTimes"
                            ? "70px"
                            : "auto",
          };
        }
      });
    },
    async getTableData() {
      const response = await useJwt.post(`getListCamp`, this.serverParams);
      if (response.data.code === 200) {
        this.tableData = response.data.result;
        this.totalRecords = response.data.totalRecords;
      } else {
        this.tableData = [];
        this.totalRecords = 0;
      }
      const column = [
        {id: "ID"},
        {name: "Tên PYC"},
        {notiQuantity: "Số lượng tin"},
        {createdDate: "Ngày tạo"},
        {startDate: "Thời gian bắt đầu"},
        {endDate: "Thời gian kết thúc"},
        {status: "Trạng thái"},
        {action: "Thao tác"},
      ];
      this.getFieldsTable(column);
    },
    getDateTime(e) {
      return moment(e).isValid() ? moment(e).format("DD/MM/YYYY HH:mm:ss") : "";
    },
    async getDetailData(id) {
      // const response = await useJwt.get(`ob/detail/${id}`);
      // if (response.data.code == 200) {
      //   const results = response.data.extra.Results || {};
      //   this.detailQuestions = response.data.result.map((el) => {
      //     return {
      //       ...el,
      //       value:
      //         this.selectedRecord.Status === 2 || this.selectedRecord.Status === 3
      //           ? results[el.id]
      //           : null,
      //     };
      //   });
      //   this.detailQuestionExtra = response.data.extra;
      //   this.detailColumnExtra = response.data.extra.DetailColumn.map((el) => {
      //     let key = Object.keys(el)[0];
      //     let label = el[key];
      //     return { key, label };
      //   });
      // } else {
      //   this.detailQuestions = [];
      //   this.detailQuestionExtra = {};
      //   this.detailColumnExtra = [];
      // }
    },
    async onDelete(item) {
      this.currentItem = item;
      var res = await this.$bvModal.msgBoxConfirm("Bạn có chắc chắn muốn xóa PYC", {
        title: "Xóa PYC",
        size: "sm",
      });

      if (res) {
        const response = await useJwt.get(`deletePYC/${item.id}`);
        if (response.data.code === 200) {
          this.getTableData();
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Xoá thành công!",
              icon: "CheckSquareIcon",
              variant: "primary",
            },
          });
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Xóa không thành công!",
              icon: "AlertTriangleIcon",
              variant: "warning",
            },
          });
        }
      }
    },
  },
  data() {
    return {
      isCreateForm: false,
      appointmentTime: null,
      callStatusSelected: 1,
      detailColumnExtra: [],
      selectedTab: 0,
      selectedOrderTime: 0,
      serverParams: {
        columnFilters: {},
        sort: [],
        page: 1,
        pageSize: 10,
        id: "",
        createdDate: "",
        startDate: "",
        endDate: "",
        status: 0,
        type: 0,
      },
      totalRecords: 0,
      isLoading: false,
      callStatus: [],
      group: [],
      questionType: [],
      status: [
        {
          value: "",
          text: "Tất cả",
        },
        {
          value: 1,
          text: "Đủ điều kiện",
        },
        {
          value: 0,
          text: "Không đủ điều kiện",
        },
      ],
      tableData: [],
      exportTableData: [],
      selectedRecord: null,
      detailQuestions: [],
      detailQuestionExtra: {},
      fields: [
        {
          field: "action",
          filterOptions: {enabled: false, placeholder: ""},
          label: "Action",
          required: true,
          disabled: true,
          width: "100px",
        },
      ],
      timeOut: null,
      dropListSelectData: [],
    };
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";

.modal-activated-order {
  height: 700px;
  color: #000000;
}

.col-700-scroll {
  height: 680px;
  overflow: auto;
}

.vpbank-tb-container .line-numbers,
th.vgt-left-align {
  background: linear-gradient(#f4f5f8, #f1f3f6) !important;
}

.vpbank-tb-container td {
  height: 34.4px !important;
}
</style>
<style scoped>
.error-txt small {
  color: red;
}

.unselected {
  background: rgb(175, 175, 175) !important;
  border: rgb(175, 175, 175) !important;
}

.text-end {
  text-align: end;
}

.action-col {
  width: 100%;
  display: flex;
  justify-content: center;
}

.order-id:hover {
  cursor: pointer;
  font-weight: bold;
  color: rgb(34, 100, 243);
}

.detail-custom-table {
  width: 100%;
}

.detail-custom-table {
  display: inline-table;
  border: solid 1px rgb(207 207 207);
}

.detail-custom-table th,
.detail-custom-table td {
  border: solid 1px rgb(207 207 207);
  padding: 5px 10px;
}

.detail-custom-table th {
  vertical-align: baseline;
}

.history-call__header {
  display: flex;
  justify-content: space-between;
  padding: 20px;
}

.history-call__header h5 {
  margin: 0;
}

.note-question {
  font-style: italic;
  color: rgb(233, 71, 22);
  margin-bottom: 9px;
}

.action-container {
  display: flex;
  justify-content: center;
  width: 100%;
}

.action-container button {
  margin: 0 10px;
}

.status-info {
  padding: 4px 8px;
  border-radius: 5px;
  background: rgb(242, 242, 112);
  color: red;
  font-weight: bold;
}
</style>
